<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">即売会参加情報
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">直近の参加予定即売会について</h2>
            <p v-if="recentEvents.length" class="lead">直近4ヵ月の参加予定の即売会は以下の通りです。</p>
            <p v-else class="lead">直近4ヵ月で参加予定の即売会はありません。</p>
          </div>
        </div>
        <div v-for="(item,index) in recentEvents" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.Name }}</h3>
                <h5>開催日：{{ item.StartDate }}</h5>
                <h5>ジャンル：{{ item.Junle }}</h5>
                <h5>場所：{{ item.Prefecture }}・{{ item.Place }}</h5>
                <h5>状態：{{ item.EventStatus }}</h5>
                <div v-if="item.EventStatus == '参加' || item.EventStatus == '終了' || item.EventStatus == 'Placed' || item.EventStatus == 'Finished'">
                  <h5>配置：{{ item.Position }}</h5>
                </div>
                <p v-html="item.Description"></p>
                <div class="btn-wrapper">
                  <router-link :to="item.EventDetailUrl">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-calendar-grid-58">
                      詳細情報
                    </base-button>
                  </router-link>
                  &nbsp;
                  <span v-if="item.Url">
                    <a :href="item.Url" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="primary"
                                   icon="ni ni-building">
                        イベントHP
                      </base-button>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.CircleCutUrl class="img-fluid shadow">
            </div>
          </div>
          <hr v-show="index !== recentEvents.length - 1">
        </div>
      </div>
    </section>
    <section class="section section-lg bg-secondary">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">過去に参加した即売会</h2>
          </div>
        </div>
        <BCard header="フィルタ" header-bg-variant="primary" header-text-variant="white" class="mb-5 mt-5">
          <div class="row mb-4">
            <div class="col-md-6">
              <label for="genre-select-events">ジャンル</label>
              <BFormSelect id="genre-select-events" v-model="genreFilter" :options="uniqueGenres" />
            </div>
            <div class="col-md-6">
              <label for="area-select">開催地域</label>
              <BFormSelect id="area-select" v-model="areaFilter" :options="uniqueAreas" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-4">
              <label for="start-date-events">開催日（From）</label>
              <flat-pickr id="start-date-events" v-model="startDate" :config="flatpickrConfig" class="form-control" />
            </div>
            <div class="col-md-4">
              <label for="end-date-events">開催日（To）</label>
              <flat-pickr id="end-date-events" v-model="endDate" :config="flatpickrConfig" class="form-control" />
            </div>
            <div class="col-md-4">
              <label for="prefecture-select">都道府県</label>
              <BFormSelect id="prefecture-select" v-model="prefectureFilter" :options="uniquePrefectures" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12 text-center">
              <BButton @click="resetFilters" variant="primary">フィルタをリセット</BButton>
            </div>
          </div>
        </BCard>
        <div v-for="(item,index) in filteredPreviousEvents" :key="item.id">
          <div class="row row-grid align-items-center pb-100">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.Name }}</h3>
                <h5>開催日：{{ item.StartDate }}</h5>
                <h5>ジャンル：{{ item.Junle }}</h5>
                <h5>場所：{{ item.Prefecture }}・{{ item.Place }}</h5>
                <h5>状態：{{ item.EventStatus }}</h5>
                <div v-if="item.EventStatus == '参加' || item.EventStatus == '終了' || item.EventStatus == 'Placed' || item.EventStatus == 'Finished'">
                  <h5>配置：{{ item.Position }}</h5>
                </div>
                <p v-html="item.Description"></p>
                <div class="btn-wrapper">
                  <router-link :to="item.EventDetailUrl">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-calendar-grid-58">
                      詳細情報
                    </base-button>
                  </router-link>
                  &nbsp;
                  <span v-if="item.Url">
                    <a :href="item.Url" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="primary"
                                   icon="ni ni-building">
                        イベントHP
                      </base-button>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.CircleCutUrl class="img-fluid shadow">
            </div>
          </div>
          <hr v-show="index !== filteredPreviousEvents.length - 1">
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'
import 'moment/locale/ja'
import moment from "moment";
import { BFormSelect, BFormInput, BButton, BCard } from 'bootstrap-vue-next';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Japanese} from "flatpickr/dist/l10n/ja";

export default {
  setup() {
    useHead({
      meta: [
        { property: 'og:title', content: '雛菊書房 - 即売会参加情報' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」の即売会参加情報' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    })
  },
  name: "events",
  components: {
    moment,
    BFormSelect,
    BFormInput,
    BButton,
    BCard,
    FlatPickr
  },
  data() {
    return{
      recentEvents: [],
      previousEvents: [],
      genreFilter: null,
      startDate: null,
      endDate: null,
      areaFilter: null,
      prefectureFilter: null,
      flatpickrConfig: {
        locale: Japanese,
        dateFormat: 'Y/m/d',
        altFormat: 'Y/m/d',
        altInput: true,
        allowInput: true,
      },
    };
  },
  created() {
    moment.locale('ja')
    this.getRecentEvents()
    this.getPreviousEvents()
  },
  computed: {
    uniqueGenres() {
      const genres = [...new Set(this.previousEvents.map(event => event.Junle))];
      return [{ value: null, text: '全て' }, ...genres.map(genre => ({ value: genre, text: genre }))];
    },
    uniqueAreas() {
      const areas = [...new Set(this.previousEvents.map(event => event.Area).filter(Boolean))];
      return [{ value: null, text: '全て' }, ...areas.map(area => ({ value: area, text: area }))];
    },
    uniquePrefectures() {
      const prefectures = [...new Set(this.previousEvents.map(event => event.Prefecture).filter(Boolean))];
      return [{ value: null, text: '全て' }, ...prefectures.map(pref => ({ value: pref, text: pref }))];
    },
    filteredPreviousEvents() {
      return this.previousEvents.filter(event => {
        const matchesGenre = this.genreFilter ? event.Junle === this.genreFilter : true;
        const matchesStartDate = this.startDate ? moment(event.StartDate).isSameOrAfter(moment(this.startDate, 'YYYY/M/D')) : true;
        const matchesEndDate = this.endDate ? moment(event.EndDate).isSameOrBefore(moment(this.endDate, 'YYYY/M/D')) : true;
        const matchesArea = this.areaFilter ? event.Area === this.areaFilter : true;
        const matchesPrefecture = this.prefectureFilter ? event.Prefecture === this.prefectureFilter : true;
        return matchesGenre && matchesStartDate && matchesEndDate && matchesArea && matchesPrefecture;
      });
    },
  },
  methods: {
    getRecentEvents() {
      let today = moment()
      let four_month = moment().add(4, 'month')
      this.axios.get('/strapi/api/event-informations?populate=%2A&sort[0]=StartDate%3Aasc&filters[StartDate][$gte]=' + today.format('YYYY-MM-DD') + '&filters[EndDate][$lte]=' + four_month.format('YYYY-MM-DD'))
          .then(response => {
            this.recentEvents = response.data.data
            this.recentEvents.forEach(function (value, index, array){
              const normally_held = ['Announced', 'Planning', 'Submitted', 'Listed', 'Placed']
              array[index]['StartDate'] = moment(value['StartDate'], 'YYYY-MM-DD').format('YYYY/MM/DD(ddd)')
              array[index]['EndDate'] = moment(value['EndDate'], 'YYYY-MM-DD').format('YYYY/MM/DD(ddd)')
              if (value['EventStatus'] == "Announced"){
                array[index]['EventStatus'] = "開催告知あり"
              } else if (value['EventStatus'] == "Planning"){
                array[index]['EventStatus'] = "参加予定"
              } else if (value['EventStatus'] == "Submitted"){
                array[index]['EventStatus'] = "申込済み"
              } else if (value['EventStatus'] == "Listed"){
                array[index]['EventStatus'] = "配置発表待ち（当選済み）"
              } else if (value['EventStatus'] == "Placed"){
                array[index]['EventStatus'] = "参加"
              } else if (value['EventStatus'] == "Finished"){
                array[index]['EventStatus'] = "終了"
              } else if (value['EventStatus'] == "Suspended"){
                array[index]['EventStatus'] = "中止/延期"
              } else if (value['EventStatus'] == "Postponed"){
                array[index]['EventStatus'] = "延期"
              } else if (value['EventStatus'] == "Cancelled"){
                array[index]['EventStatus'] = "中止"
              } else if (value['EventStatus'] == "Declined"){
                array[index]['EventStatus'] = "欠席/辞退"
              }
              if (array[index]['Description'] !== null){
                array[index]['Description'] = value['Description'].replace(/\r?\n/g, '<br >');
              }
              array[index]['EventDetailUrl'] = "eventDetail/" + value['EventId']
              if(array[index]['CircleCut']){
                if ('formats' in value['CircleCut'] && 'small' in value['CircleCut']['formats']){
                  fetch('/strapi' + value['CircleCut']['formats']['small']['url']).then(response => {
                    if (response.ok) {
                      array[index]['CircleCutUrl'] = '/strapi' + value['CircleCut']['formats']['small']['url']
                    } else {
                      array[index]['CircleCut']['Url'] = '/strapi' + value['CircleCut']['url']
                    }
                  })
                } else {
                  array[index]['CircleCutUrl'] = '/strapi' + value['CircleCut']['url']
                }
              }
            })
          }).catch(error =>{
        console.log(error)
      })
    },
    getPreviousEvents() {
      let today = moment()
      this.axios.get('/strapi/api/event-informations?populate=%2A&pagination[pageSize]=100&sort[0]=StartDate%3Adesc&filters[StartDate][$lt]=' + today.format('YYYY-MM-DD'))
          .then(response => {
            this.previousEvents = response.data.data
            this.previousEvents.forEach(function (value, index, array){
              const normally_held = ['Announced', 'Planning', 'Submitted', 'Listed', 'Placed']
              array[index]['StartDate'] = moment(value['StartDate'], 'YYYY-MM-DD').format('YYYY/MM/DD(ddd)')
              array[index]['EndDate'] = moment(value['EndDate'], 'YYYY-MM-DD').format('YYYY/MM/DD(ddd)')
              if (normally_held.includes(value['EventStatus']) && moment(value['EndDate'], 'YYYY-MM-DD').isBefore(today)){
                array[index]['EventStatus'] = "終了"
              } else if (value['EventStatus'] == "Announced"){
                array[index]['EventStatus'] = "開催告知あり"
              } else if (value['EventStatus'] == "Planning"){
                array[index]['EventStatus'] = "参加予定"
              } else if (value['EventStatus'] == "Submitted"){
                array[index]['EventStatus'] = "申込済み"
              } else if (value['EventStatus'] == "Listed"){
                array[index]['EventStatus'] = "配置発表待ち（当選済み）"
              } else if (value['EventStatus'] == "Placed"){
                array[index]['EventStatus'] = "参加"
              } else if (value['EventStatus'] == "Finished"){
                array[index]['EventStatus'] = "終了"
              } else if (value['EventStatus'] == "Suspended"){
                array[index]['EventStatus'] = "中止/延期"
              } else if (value['EventStatus'] == "Postponed"){
                array[index]['EventStatus'] = "延期"
              } else if (value['EventStatus'] == "Cancelled"){
                array[index]['EventStatus'] = "中止"
              } else if (value['EventStatus'] == "Declined"){
                array[index]['EventStatus'] = "欠席/辞退"
              }
              if (array[index]['Description'] !== null){
                array[index]['Description'] = value['Description'].replace(/\r?\n/g, '<br >');
              }
              array[index]['EventDetailUrl'] = "eventDetail/" + value['EventId']
              if(array[index]['CircleCut']){
                if ('formats' in value['CircleCut'] && 'small' in value['CircleCut']['formats']){
                  fetch('/strapi' + value['CircleCut']['formats']['small']['url']).then(response => {
                    if (response.ok) {
                      array[index]['CircleCutUrl'] = '/strapi' + value['CircleCut']['formats']['small']['url']
                    } else {
                      array[index]['CircleCut']['Url'] = '/strapi' + value['CircleCut']['url']
                    }
                  })
                } else {
                  array[index]['CircleCutUrl'] = '/strapi' + value['CircleCut']['url']
                }
              }
            })
          }).catch(error =>{
        console.log(error)
      })
    },
    resetFilters() {
      this.genreFilter = null;
      this.startDate = null;
      this.endDate = null;
      this.areaFilter = null;
      this.prefectureFilter = null;
    }
  }
};
</script>
<style>
</style>
